module.exports = __webpack_public_path__ + "static/media/stripe-onboarding_6.a55141bf.png";